import React, { Component } from 'react';
import { connect } from 'react-redux';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../Globals/styles';
import animations from '../../Globals/animations';
import DatepickerOnWeeks from '../../Common/datepickerOnWeeks';
import ActivityTable from './activityTable';
import Chat from './Chat';
import * as actions from './actions';
import SmartSpinner from '../../Common/SmartSpinner'
import Pool from './Pool';

//TODO
//update total registreret i kanban

class RegisterActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChat: false,
      updatePoolVal: null,
      currDate: new Date()
    }
  }
  componentWillMount = () => {
    this.props.dispatch(actions.fetchActivity(this.props.params.activityId, this.state.currDate));
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.params.activityId !== this.props.params.activityId)
      this.props.dispatch(actions.fetchActivity(nextProps.params.activityId, this.state.currDate));
    if (nextProps.unread) {
      this.setState({
        showChat: this.props.unread.indexOf(this.props.rootActivity.id) !== -1
      })
    }

  };
  onPoolUpdate = (val) => {
    this.setState({ updatePoolVal: val });
  };
  changeDate = (newDate) => {
    this.setState({ currDate: newDate });
    this.props.dispatch(actions.fetchActivity(this.props.params.activityId, newDate))
  };

  render() {
    const { params, rootActivity,
      subActivities, activities, dispatch, employees, employees2 } = this.props;

    return (
      <div className="row" style={styles.innerContainer}>
        {!rootActivity.id ?
          <div style={styles.loadingIcon}>Indlæser...
            <i className="fa fa-spinner fa-spin fa-2x" />
          </div>
          :

          /*  CONTENT START */
          <div style={styles.content}>
            {/*  LEFT SIDE CONTENT */}
            <div className="col-xs-12" style={styles.leftSideContainer}>
              {/* DATE SWITCHER */}
              <div className="row" style={styles.datepickerRow}>
                <div className="col-xs-11">
                  <DatepickerOnWeeks
                    defaultValue={this.state.currDate}
                    onChange={this.changeDate}
                  />
                </div>
                <div className="col-xs-1 text-right">
                  <SmartSpinner />
                </div>
              </div>

              <div className="row" style={[styles.height100, styles.width100]}>
                {/* DAGENS REGISTRERING SIDE */}
                <div className="col-xs-4" style={[styles.height100, styles.leftSide]}>
                  <div className="text-center" style={styles.switchBtnsRow}>
                    {/*show Pool*/}
                    <div
                      key={1} className="waves-btn"
                      style={[styles.switchBtns, !this.state.showChat && styles.active]}
                      onClick={() => { this.setState({ showChat: false }) }}
                    >
                      <i className="fa fa-clock-o" />
                      <div style={styles.switchBtns.label}>TIMEPULJE</div>
                    </div>
                    {/*show Chat*/}
                    <div
                      key={2} className="waves-btn"
                      style={[styles.switchBtns, this.state.showChat && styles.active]}
                      onClick={() => { this.setState({ showChat: true }) }}
                    >
                      <i className="fa fa-envelope" />
                      <div style={styles.switchBtns.label}>BESKEDER</div>
                    </div>
                  </div>

                  {this.state.showChat ?
                    <div style={styles.wrapChat}>
                      <Chat
                        activityId={params.activityId}
                      />
                    </div>
                    :
                    <Pool
                      employees={employees}
                      employees2={employees2}
                      rootActivity={rootActivity}
                    />
                  }
                </div>

                {/* ACTIVITY TABLE SIDE */}
                <div className="col-xs-8" style={styles.activityTableContainer}>
                  {/*LOADER*/}
                  <ActivityTable
                    rootActivity={rootActivity}
                    subActivities={subActivities}
                    activities={activities}
                    addNewActivity={(val, id) => dispatch(actions.addActivity(val, id))}
                    onActivityChange={(id, value, oldValue) => dispatch(actions.submitActivities(this.state.currDate, id, value, oldValue))}
                    renameActivities={(renamedActivities) => dispatch(actions.renameActivities(renamedActivities))}
                  />
                </div>
              </div>
            </div>
            {/*CONTENT END*/}
          </div>}
      </div>);
  }
}

var styles = {
  content: {
    height: '100%'
  },
  innerContainer: {
    height: '100%',
    backgroundColor: semanticColors.default
  },
  loaderContainer: {
    position: 'absolute',
    top: '-74px',
    right: '48px'
  },
  fadeOut: {
    animation: animations.fadeOut
  },
  leftSideContainer: {
    height: '100%',
    padding: '30px 0px 90px 0px',
    position: 'relative'
  },
  height100: {
    height: '100%'
  },
  width100: {
    width: '100%'
  },
  loadingIcon: {
    fontSize: '22px',
    textAlign: 'center',
    height: '100px',
    width: '100px',
    marginTop: '-50px',
    marginLeft: '-50px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    color: greyScaleColors.greyDark
  },
  dayText: {
    padding: '0 9px'
  },
  dayTexth3: {
    marginTop: '15px'
  },
  h4: {
    fontSize: '18px',
    fontWeight: '600',
    marginTop: '-11px',
    marginBottom: '28px'
  },
  dayRegistration: {
    height: '100%',
    borderRight: '1px solid',
    textAlign: 'center',
    borderColor: greyScaleColors.greyLighter
  },
  canvas: {
    marginBottom: '30px',
    font: "bold 24px Open Sans",
    fillDef: semanticColors.text,
    fillRed: semanticColors.danger,
    fillSuccess: semanticColors.success,
    textAlign: "center",
    verticalAlign: "middle"
  },
  registeredHours: {
    fontSize: '45px',
    fontWeight: 'bold',
    marginTop: '30px'
  },
  employeesContainer: {
    marginTop: '40px',
    width: '100%',
    display: 'inline-block',
    padding: '12px'
  },
  employee: {
    width: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    paddingLeft: '12px'
  },
  activityTableContainer: {
    height: '100%',
    paddingRight: '0px'
  },
  chatContainer: {
    height: '100%',
    padding: '0'
  },
  registrationContainer: {
    padding: '40px 20px 0 20px',
    marginLeft: '12px'
  },
  registrationButton: {
    marginTop: '20px'
  },
  datepickerRow: {
    marginBottom: '30px',
    width: '100%',
    height: '42px'
  },
  switchBtns: {
    width: '80px',
    padding: '0px',
    cursor: 'pointer',
    fontSize: '26px',
    marginRight: '15px',
    marginLeft: '15px',
    color: greyScaleColors.greyLight,
    textAlign: 'center',
    ':hover': {
      color: semanticColors.infoHover
    },
    label: {
      fontSize: '13px',
      fontWeight: 'bold'
    }
  },
  switchBtnsRow: {
    position: 'absolute',
    height: '55px',
    top: '0',
    left: '0',
    width: '100%'
  },
  active: {
    color: semanticColors.info
  },
  wrapChat: {
    height: '100%',
    paddingTop: '85px',
    paddingLeft: '12px'

  },
  leftSide: {
    borderRight: '1px solid ' + greyScaleColors.greyLighter
  }
}

const selectProps = state => {
  return {
    ...state.registerActivitiesReducer,
    unread: state.activityOverviewReducer.unread
  };
}

export default connect(selectProps)(Radium(RegisterActivity));


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/RegisterActivity.jsx